import React from 'react';

import { OverlayVideoBackground, OverlayVideoContent, OverlayVideoPlayer } from './overlay.video.styles';

interface OverlayVideoProps {
  overlayVisible: boolean;
  setOverlayVisible: (value: boolean) => void;
  src: string;
}

const OverlayVideo = ({ overlayVisible, setOverlayVisible, src }: OverlayVideoProps): JSX.Element => {
  
  return overlayVisible && (
    <>
      <OverlayVideoBackground onClick={() => setOverlayVisible(!overlayVisible)} />
      <OverlayVideoContent>
        <div onClick={() => setOverlayVisible(!overlayVisible)}>
          ×
        </div>
        <OverlayVideoPlayer autoPlay controls>
          <source type="video/mp4" src={src} />
        </OverlayVideoPlayer>
      </OverlayVideoContent>
    </>
  )
};

export default OverlayVideo;
